/**
 * 语言配置-简体中文
 */
export const zh_cn_Language = {

};



// WEBPACK FOOTER //
// ./src/language/package/zh-cn.js